import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS, Validator, ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

@Directive({
  selector: '[userValidator]',
  providers: [{ provide: NG_VALIDATORS, useExisting: UserValidatorDirective, multi: true }],
  standalone: false
})
export class UserValidatorDirective implements Validator {
  @Input('userValidator') userValidator = '';

  userValidatorFn(nameRe: RegExp): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const valid = nameRe.test(control.value);
      return !valid ? { userInvalid: { value: control.value } } : null;
    };
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.userValidator ? this.userValidatorFn(new RegExp(this.userValidator, 'i'))(control)
      : null;
  }
}
